<template>
  <div class="skill-rating">
    <div class="stars">
      <div 
        v-for="star in 5" 
        :key="star"
        class="star"
        :class="{ 'filled': star <= rating, 'half-filled': star - 0.5 === rating }"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"/>
        </svg>
      </div>
    </div>
    <span class="skill-name">{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: 'SkillRating',
  props: {
    name: {
      type: String,
      required: true
    },
    rating: {
      type: Number,
      required: true,
      validator: value => value >= 0 && value <= 5
    }
  }
}
</script>

<style lang="scss" scoped>
.skill-rating {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0;
}

.stars {
  display: flex;
  gap: 0.25rem;
}

.star {
  width: 20px;
  height: 20px;
  color: var(--color-border);
  transition: color 0.3s ease;

  &.filled {
    color: var(--color-primary);
  }

  &.half-filled {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 50%;
      height: 100%;
      background-color: var(--color-primary);
      mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z'/%3E%3C/svg%3E") no-repeat left center;
      mask-size: 200% 100%;
      -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z'/%3E%3C/svg%3E") no-repeat left center;
      -webkit-mask-size: 200% 100%;
    }
  }
}

.skill-name {
  font-size: 1rem;
  color: var(--color-text);
}
</style>